export enum AnalyticsDevFlag {
  AtsBasicCandidateFields = 'ats_basic_candidate_fields',

  HrCustomFields = 'hr_custom_fields',
}

export type AnalyticsDevFlagsMap = Record<AnalyticsDevFlag, boolean>;

export type AnalyticsDevFlagsFetchResponse = {
  features: AnalyticsDevFlag[];
};
